import { ThemeOptions } from "@mui/material/styles";

const REM_MULTIPLE = 0.5 as const;

export const spacingOptions: ThemeOptions["spacing"] = (abs: number) =>
  abs !== 0 ? REM_MULTIPLE * abs + "rem" : 0;
